import { render, staticRenderFns } from "./JSIcon.vue?vue&type=template&id=0b34ed98&scoped=true"
import script from "./JSIcon.vue?vue&type=script&lang=js"
export * from "./JSIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b34ed98",
  null
  
)

export default component.exports